import { RootStateOrAny, useSelector } from 'react-redux'
import styled from 'styled-components'

const QuoteProgressContainer = styled.div`
  background: var(--color-gradient);
  display: flex;
  padding-bottom: 7px;
  margin: 33px 0 40px 0;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    right: 0;
    height: 33px;
    background: #f4f4f4;
    width: 2px;
  }

  .step {
    background: var(--color-soft-white);
    position: relative;
    text-align: center;
    padding-top: 5px;
    flex-grow: 0;
    padding-bottom: 8px;
    font-size: 0.75rem;
    font-weight: 600;
    color: #666666;
    padding-top: 3px;

    &.w20 {
      width: 20%;
    }

    &.w25 {
      width: 25%;
    }

    &:after {
      content: '';
      position: absolute;
      background: #f4f4f4;
      height: 4px;
      bottom: -4px;
      width: 100%;
      left: 0;
    }

    &.active {
      color: black;
      font-weight: bold;
      font-size: 0.875rem;
      padding-top: 0px;

      &:after {
        content: unset;
      }
    }
  `

interface Props {
  projectType?: string
}

const QuoteProgress = ({ projectType }: Props) => {
  const { project } = useSelector(
    (state: RootStateOrAny) => state.projectDetails
  )
  const { currentStep } = useSelector(
    (state: RootStateOrAny) => state.projectStep
  )

  return (
    <QuoteProgressContainer>
      {currentStep < 6 ? (
        <>
          <div
            className={`step w20 ${currentStep === 1 || !currentStep ? 'active' : ''
              }`}
          >
            Create new request
          </div>
          <div className={`step w20 ${currentStep === 2 ? 'active' : ''}`}>
            Part details
          </div>
          <div className={`step w20 ${currentStep === 3 ? 'active' : ''}`}>
            {projectType === 'inspection' ||
              (project && project.type === 'inspection')
              ? 'Program details'
              : 'Machine details'}
          </div>
          <div className={`step w20 ${currentStep === 4 ? 'active' : ''}`}>
            Report requirements
          </div>
          <div className={`step w20 ${currentStep === 5 ? 'active' : ''}`}>
            Estimated costs
          </div>
        </>
      ) : (
        <>
          <div className={`step w25 ${currentStep === 6 ? 'active' : ''}`}>
            Select timeframe
          </div>
          <div className={`step w25 ${currentStep === 7 ? 'active' : ''}`}>
            Delivery details
          </div>
          <div className={`step w25 ${currentStep === 8 ? 'active' : ''}`}>
            Add-on services
          </div>
          <div className={`step w25 ${currentStep === 9 ? 'active' : ''}`}>
            Submit request
          </div>
        </>
      )}
    </QuoteProgressContainer>
  )
}

export default QuoteProgress
